import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';

import { WCPageDetailsResponseJSON } from "../common/JSON/wcPage/WC-Page-Details-Response-JSON";
import { SurveyDeployerWCPageRequestJSON } from "../common/JSON/RequestTOJSON/Survey-Deployer-WC-Page-Request.JSON";
import { SessionService } from '../session.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SurveyDeployerQuestionPageRequestJSON } from 'app/common/JSON/RequestTOJSON/Survey-Deployer-Question-Page-Request.JSON';

@Injectable()
export class WelcomePageService {
    private generateURL: string;
    private saveWCPUrl: string;
    private getQPUrl: string;
    private saveQPUrl:string;

    wcPageDetailData: WCPageDetailsResponseJSON;
    request: SurveyDeployerWCPageRequestJSON;
    isHistoricalFlag: boolean;

    
    constructor(private http: HttpClient,private sessionService: SessionService) {
        // this.generateURL = this.sessionService.baseURL+"/services/altSurveyDeployer/generate";
        // this.saveWCPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveWelcomePageInfo";
        // this.getQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/questionsDetail";
        // this.saveQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveQuestionDetails";
    }

    private urlMappings(){
        this.generateURL = this.sessionService.baseURL+"/services/altSurveyDeployer/generate";
        this.saveWCPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveWelcomePageInfo";
        this.getQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/questionsDetail";
        this.saveQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveQuestionDetails";
    }

    private getHeaders() {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return headers;
    
    }

    private getHeaders1() {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return headers;
    }

    private getHeaders2() {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Content-Type', 'text/plain');
        return headers;
    }

    getWelcomePageDetails(surveyDeployerWCPageRequestJSON: SurveyDeployerWCPageRequestJSON): Observable<any> {
        const headers = this.getHeaders1();
        if(surveyDeployerWCPageRequestJSON.isHistorical == null){
            surveyDeployerWCPageRequestJSON.isHistorical = false;
        }
        let body = `contextEntityId=${surveyDeployerWCPageRequestJSON.contextEntityId}&contextInstanceId=${surveyDeployerWCPageRequestJSON.contextInstanceId}&tenantId=${surveyDeployerWCPageRequestJSON.tenantId}&organizationId=${surveyDeployerWCPageRequestJSON.organizationId}&editable_true=${surveyDeployerWCPageRequestJSON.editable_true}&userID=${surveyDeployerWCPageRequestJSON.userID}&link=${surveyDeployerWCPageRequestJSON.link}&roleID=${surveyDeployerWCPageRequestJSON.roleID}&sysSurveyRunID=${surveyDeployerWCPageRequestJSON.sysSurveyRunID}&isHistorical=${surveyDeployerWCPageRequestJSON.isHistorical}`;
        this.urlMappings();
        return this.http.post(this.generateURL, body, {headers})
            .timeout(200000);
          
    }

    setWelcomePageDetailData(wcPageDetailData: WCPageDetailsResponseJSON) {
        this.wcPageDetailData = wcPageDetailData;
    }

    postUserInfo(surveyDeployerWCPageRequestJSON): Observable<any>{
        let headers = this.getHeaders2();
        this.request = surveyDeployerWCPageRequestJSON;
        this.urlMappings();
        return this.http.post(this.saveWCPUrl, JSON.stringify(this.request), {headers})
            .timeout(200000);
    }

    getQuestionDetailsData(surveyId): Observable<any>{
        let headers = this.getHeaders();
        var data = {"surveyID":surveyId};
        this.urlMappings();
        return this.http.post(this.getQPUrl, JSON.stringify(data), {headers})
            .timeout(200000);
    }
}
